import { IAsset } from "../../models/IAsset";

export class AssetState {
  assetsList: IAsset[] = [];
}
